<script>
import { gwpFactors as _API_, gwpGroups as _PARENT_API_ } from "./api-calls";

export default {
    data() {
        return {
            parentData: [],
            data: [],

            selectedLanguage: 'en',
            languages: [
                { value: 'en', text: 'EN' },
                { value: 'tr', text: 'TR' },
            ],

            headers: [
                {
                    key: '#',
                    in: 'index',
                    style: {
                        'flex': 2,
                        'text-align': 'center'
                    }
                },
                {
                    key: 'formula',
                    in: 'main_data',
                    style: {
                        'flex': 4,
                        'text-align': 'left'
                    }
                },
                {
                    key: 'composition',
                    in: 'main_data',
                    style: {
                        'flex': 5,
                        'text-align': 'left'
                    }
                },
                {
                    key: 'name',
                    in: 'text_data',
                    style: {
                        'flex': 4,
                        'text-align': 'left'
                    }
                },
                {
                    key: 'description',
                    in: 'text_data',
                    style: {
                        'flex': 5,
                        'text-align': 'left'
                    }
                },
                {
                    key: 'factor_value',
                    in: 'main_data',
                    style: {
                        'flex': 2,
                        'text-align': 'left'
                    }
                },
                {
                    key: 'source_name',
                    in: 'main_data',
                    style: {
                        'flex': 4,
                        'text-align': 'left'
                    }
                },
                {
                    key: 'source_link',
                    in: 'main_data',
                    style: {
                        'flex': 4,
                        'text-align': 'left'
                    }
                },
            ],

            createData: undefined,
            editData: undefined,
        }
    },

    computed: {

    },

    async mounted() {
        await this.fetchParentRequest();
        await this.fetchRequest();
    },

    methods: {
        async fetchParentRequest() {
            await _PARENT_API_.fetch()
                .then(res => {
                    this.parentData = res.data;
                })
        },

        async fetchRequest() {
            await _API_.fetch()
                .then(res => {
                    this.data = res.data;
                })
        },
        
        async createRequest() {
            const params = {
                id: undefined,
                body: this.createData
            };

            await _API_.create(params)
                .then(res => {
                    this.data.push(
                        {
                            main_data: {
                                id: res.data.value,
                                created_by: this.$user.user_id,
                                created_on: new Date(),
                                ...this.createData.main_data
                            },
                            text_data: this.createData.text_data
                        }
                    );

                    this.$notify('success', res.data.messageName);
                })
                .catch(({ response }) => {
                    this.$notify('error', response.data.messageName);
                })
        },
        
        async updateRequest() {
            const params = {
                id: this.editData.main_data.id,
                body: this.editData
            };
            await _API_.update(params)
                .then(res => {
                    this.editData.updated_by = this.$user.user_id,
                    this.editData.updated_on = new Date(),
                    this.$notify('success', res.data.messageName);
                })
                .catch(({ response }) => {
                    this.$notify('error', response.data.messageName);
                })
        },
        
        async deleteRequest() {
            const params = {
                id: this.editData.main_data.id,
                body: undefined
            };
            await _API_.delete(params.id)
                .then(res => {
                    this.editData.main_data.is_deleted = true;
                    this.$notify('success', res.data.messageName);
                })
                .catch(({ response }) => {
                    this.$notify('error', response.data.messageName);
                })
                .finally(() => {
                    this.$refs.editPopup.startHideProcess();
                })
        },

        async handleClickCreate() {
            await this.setupCreateData();
            this.$refs.createPopup.openPopup();
        },

        async setupCreateData() {
            this.createData = {
                main_data: {
                    group_id: null,
                    formula: null,
                    composition: null,
                    factor_value: null,
                    source_name: null,
                    source_link: null,
                },
                text_data: {
                    tr: {
                        name: null,
                        description: null,
                    },
                    en: {
                        name: null,
                        description: null,
                    },
                },
            };
        },

        async handleClickEdit(item) {
            await this.setupEditData(item);
            this.$refs.editPopup.openPopup();
        },

        async setupEditData(item) {
            this.editData = item;
        },
    }
}
</script>

<template>
    <div class="flex-all-centered-col main-frame">
        <tab-selector 
            :options="languages" 
            :selectedTab="selectedLanguage" 
            @select-tab="($event) => selectedLanguage = $event.value"
        />

        <div class="table small-box-shadow">
            <div class="table-row headers">
                <div v-for="h in headers" :key="h.key"
                    :style="h.style"
                >
                    {{ $t(`carbon-admin.headers.${h.key}`) }}
                </div>
            </div>
    
            <div v-for="(item, idx) in data" :key="idx"
                v-show="!item.main_data.is_deleted"
                class="table-row values"
                @click="handleClickEdit(item)"
            >
                <div v-for="h in headers" :key="h.key"
                    :style="h.style"
                >
                    <span v-if="h.in === 'index'">
                        {{ idx+1 }}
                    </span>
                    <span v-else-if="h.in === 'text_data'">
                        {{ item.text_data[selectedLanguage][h.key] }}
                    </span>
                    <span v-else-if="h.key === 'composition'">
                        <span v-for="(c, c_idx) in item['main_data']['composition']" :key="c"
                            style="font-weight: bold;"
                        >
                            {{ c }} <span v-if="c_idx < item['main_data']['composition'].length-1">/</span>
                        </span>
                        <span v-if="!item['main_data']['composition']">
                            -
                        </span>
                    </span>
                    <span v-else>
                        {{ item.main_data[h.key] }}
                    </span>
                </div>
            </div>
        </div>

        <div class="flex-all-centered-row" style="justify-content: flex-end;">
            <button class="sust-btn sust-btn-green"
                @click="handleClickCreate()"
            >
                {{ $t('misc.create-new') }}
            </button>
        </div>

        <sust-popup ref="createPopup"
            size="md"
            :header="false"
            @ok="createRequest()"
            @onHide="() => createData = undefined"
        >
            <div v-if="createData" 
                class="flex-all-centered-col"
            >
                <div class="flex-all-centered-col"
                    style="margin: .35em 0;"
                >
                    <div style="font-weight: bold;">
                        {{ $t('carbon-admin.headers.gwp_group_name') }}
                    </div>
                    <select
                        v-model="createData.main_data.group_id"
                        class="sust-input-field"
                        style="width: 100%;"
                    >
                        <option 
                            v-for="group in parentData" 
                            :key="group.main_data.id" 
                            :value="group.main_data.id"
                        >
                            {{ group.text_data[selectedLanguage].name }}
                        </option>
                    </select>
                </div>
                <div class="flex-all-centered-col"
                    style="margin: .35em 0;"
                >
                    <div style="font-weight: bold;">
                        {{ $t('carbon-admin.headers.formula') }}
                    </div>
                    <input class="sust-input-field" 
                        style="width: 100%;"
                        type="text" 
                        v-model="createData.main_data.formula"
                    >
                </div>
                <div class="flex-all-centered-col"
                    style="margin: .35em 0;"
                >
                    <div style="font-weight: bold;">
                        {{ $t('carbon-admin.headers.factor_value') }}
                    </div>
                    <input class="sust-input-field" 
                        style="width: 100%; text-align: center;"
                        type="number" 
                        v-model="createData.main_data.factor_value"
                    >
                </div>
                <div class="flex-all-centered-col"
                    style="margin: .35em 0;"
                >
                    <div style="font-weight: bold;">
                        {{ $t('carbon-admin.headers.name') }} (EN)
                    </div>
                    <input class="sust-input-field" 
                        style="width: 100%;"
                        type="text" 
                        v-model="createData.text_data.en.name"
                    >
                </div>
                <div class="flex-all-centered-col"
                    style="margin: .35em 0;"
                >
                    <div style="font-weight: bold;">
                        {{ $t('carbon-admin.headers.name') }} (TR)
                    </div>
                    <input class="sust-input-field" 
                        style="width: 100%;"
                        type="text" 
                        v-model="createData.text_data.tr.name"
                    >
                </div>
                <div class="flex-all-centered-col"
                    style="margin: .35em 0;"
                >
                    <div style="font-weight: bold;">
                        {{ $t('carbon-admin.headers.description') }} (EN)
                    </div>
                    <textarea class="sust-input-field"
                        style="width: 100%;"
                        v-model="createData.text_data.en.description"
                        rows="3"
                    ></textarea>
                </div>
                <div class="flex-all-centered-col"
                    style="margin: .35em 0;"
                >
                    <div style="font-weight: bold;">
                        {{ $t('carbon-admin.headers.description') }} (TR)
                    </div>
                    <textarea class="sust-input-field"
                        style="width: 100%;"
                        v-model="createData.text_data.tr.description"
                        rows="3"
                    ></textarea>
                </div>
                <div class="flex-all-centered-col"
                    style="margin: .35em 0;"
                >
                    <div style="font-weight: bold;">
                        {{ $t('carbon-admin.headers.source_name') }}
                    </div>
                    <input class="sust-input-field" 
                        style="width: 100%;"
                        type="text" 
                        v-model="createData.main_data.source_name"
                    >
                </div>
                <div class="flex-all-centered-col"
                    style="margin: .35em 0;"
                >
                    <div style="font-weight: bold;">
                        {{ $t('carbon-admin.headers.source_link') }}
                    </div>
                    <input class="sust-input-field" 
                        style="width: 100%;"
                        type="text" 
                        v-model="createData.main_data.source_link"
                    >
                </div>
            </div>
        </sust-popup>
        
        <sust-popup ref="editPopup"
            size="md"
            :header="false"
            @ok="updateRequest()"
            @onHide="() => editData = undefined"
        >
            <div v-if="editData" 
                class="flex-all-centered-col"
            >
                <div class="flex-all-centered-col"
                    style="margin: .35em 0;"
                >
                    <div style="font-weight: bold;">
                        {{ $t('carbon-admin.headers.gwp_group_name') }}
                    </div>
                    <select
                        v-model="editData.main_data.group_id"
                        class="sust-input-field"
                        style="width: 100%;"
                    >
                        <option 
                            v-for="group in parentData" 
                            :key="group.main_data.id" 
                            :value="group.main_data.id"
                        >
                            {{ group.text_data[selectedLanguage].name }}
                        </option>
                    </select>
                </div>
                <div class="flex-all-centered-col"
                    style="margin: .35em 0;"
                >
                    <div style="font-weight: bold;">
                        {{ $t('carbon-admin.headers.formula') }}
                    </div>
                    <input class="sust-input-field" 
                        style="width: 100%;"
                        type="text" 
                        v-model="editData.main_data.formula"
                    >
                </div>
                <div class="flex-all-centered-col"
                    style="margin: .35em 0;"
                >
                    <div style="font-weight: bold;">
                        {{ $t('carbon-admin.headers.factor_value') }}
                    </div>
                    <input class="sust-input-field" 
                        style="width: 100%; text-align: center;"
                        type="number" 
                        v-model="editData.main_data.factor_value"
                    >
                </div>
                <div class="flex-all-centered-col"
                    style="margin: .35em 0;"
                >
                    <div style="font-weight: bold;">
                        {{ $t('carbon-admin.headers.name') }} (EN)
                    </div>
                    <input class="sust-input-field" 
                        style="width: 100%;"
                        type="text" 
                        v-model="editData.text_data.en.name"
                    >
                </div>
                <div class="flex-all-centered-col"
                    style="margin: .35em 0;"
                >
                    <div style="font-weight: bold;">
                        {{ $t('carbon-admin.headers.name') }} (TR)
                    </div>
                    <input class="sust-input-field" 
                        style="width: 100%;"
                        type="text" 
                        v-model="editData.text_data.tr.name"
                    >
                </div>
                <div class="flex-all-centered-col"
                    style="margin: .35em 0;"
                >
                    <div style="font-weight: bold;">
                        {{ $t('carbon-admin.headers.description') }} (EN)
                    </div>
                    <textarea class="sust-input-field"
                        style="width: 100%;"
                        v-model="editData.text_data.en.description"
                        rows="3"
                    ></textarea>
                </div>
                <div class="flex-all-centered-col"
                    style="margin: .35em 0;"
                >
                    <div style="font-weight: bold;">
                        {{ $t('carbon-admin.headers.description') }} (TR)
                    </div>
                    <textarea class="sust-input-field"
                        style="width: 100%;"
                        v-model="editData.text_data.tr.description"
                        rows="3"
                    ></textarea>
                </div>
                <div class="flex-all-centered-col"
                    style="margin: .35em 0;"
                >
                    <div style="font-weight: bold;">
                        {{ $t('carbon-admin.headers.source_name') }}
                    </div>
                    <input class="sust-input-field" 
                        style="width: 100%;"
                        type="text" 
                        v-model="editData.main_data.source_name"
                    >
                </div>
                <div class="flex-all-centered-col"
                    style="margin: .35em 0;"
                >
                    <div style="font-weight: bold;">
                        {{ $t('carbon-admin.headers.source_link') }}
                    </div>
                    <input class="sust-input-field" 
                        style="width: 100%;"
                        type="text" 
                        v-model="editData.main_data.source_link"
                    >
                </div>
            </div>

            <template #footer="{ hide }">
                <div class="flex-all-centered-row"
                    style="justify-content: space-between; padding: .5em;"
                >
                    <button class="sust-btn sust-btn-red"
                        @click="() => {
                            $refs.deletePopup.openPopup()
                        }"
                    >
                        {{ $t('misc.delete') }}
                    </button>

                    <div class="flex-all-centered-row"
                        style="justify-content: flex-end;"
                    >
                        <button class="sust-btn sust-btn-red"
                            @click="hide()"
                        >
                            {{ $t('misc.cancel') }}
                        </button>
                        <button class="sust-btn sust-btn-green"
                            style="margin-left: 1em;"
                            @click="() => {
                                updateRequest(); 
                                hide();
                            }"
                        >
                            {{ $t('misc.save') }}
                        </button>
                    </div>
                </div>
            </template>
        </sust-popup>

        <sust-popup ref="deletePopup"
            size="sm"
            :title="$t('carbon-admin.titles.delete')"
            @ok="deleteRequest()"
        >
            {{ $t('carbon-admin.warnings.delete') }}
        </sust-popup>
    </div>
</template>

<style lang='scss' scoped>
@import "../../../assets/css/carbon-admin-page.scss";
</style>